export default "__VITE_ASSET__DT9NqsyY__"